import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import PageTitle from "../theme/components/pagetitle";
import moment from "moment/moment";
import BlogSidebar from "../theme/components/BlogSidebar";
import Loader from "../loader";
import logger from "../../../services/logger"

export default class Article extends Component{

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const item=data[0]

        const title=item.title
        const description=item.description
        const image=item.image

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description} image={image}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div>
                <Meta context={context} title={title} description={description} image={image}/>
                <div id="main" className="main-content-wraper">
                    <Header context={context}/>
                    <PageTitle context={context} title={title} description={description}/>

                    <section className="wpo-blog-single-section section-padding">
                        <div className="container">
                            <div className="row">
                                <div className="col col-lg-8 col-12">
                                    <div className="wpo-wpo-blog-content clearfix">
                                        <div className="post">
                                            <div className="entry-media">
                                                <img src={item.image}/>
                                            </div>
                                            <ul className="entry-meta">
                                                <li><a target="_blank" href={item.credits[0].link}>{item.credits[0].name}</a></li>
                                                <li><a href={"#"}><i className="ti-calendar"></i> {moment(item.datetime).format("DD MMM YYYY")}</a>
                                                </li>
                                            </ul>
                                            <h2>{item.title}</h2>
                                            <div dangerouslySetInnerHTML={{__html: item.content}}/>
                                        </div>

                                    </div>

                                </div>
                                <BlogSidebar item={item} context={context}/>
                            </div>
                        </div>
                    </section>

                    <Footer context={context}/>
                </div>
            </div>
        )
    }
}
